import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import BreadScrumb from "../components/BreadScrumb";
import { useAuth } from "../context/UserContext";

const EarnAndReferPage = () => {
  const [showCode, setShowCode] = useState(false);
  const { user } = useAuth();
  const referralCode = user ? user[0]?.ref_code : "";
  return (
    <>
      <Header />
      <div id="content" className="no-top no-bottom">
        <BreadScrumb
          title="Refer & Earn"
          Banner="/assets/images/background/3.webp"
        />
        <div className="container mt-4">
          <div
            className="card text-center p-3"
            style={{ backgroundColor: "#73b734", color: "#fff" }}
          >
            <p>It pays to have a friend!</p>
            <p>
              Invite your friends and earn <strong>Rs.100</strong> when your
              friend sells a phone on
              <strong> AtYourDoor</strong>. Your friend also gets{" "}
              <strong>Rs.100 extra!</strong> (Min transaction Rs.1500)
            </p>
            <div className="card p-3 text-dark mx-auto inner-box">
              <p>
                <strong>Your referral code:</strong>
              </p>
              <div className="d-flex justify-content-center align-items-center">
                <span className="me-2 code-text">
                  {showCode ? referralCode : "••••••••"}
                </span>
                <button
                  style={{ height: "30px", width: "60px" }}
                  className="btn btn-outline-secondary btn-sm"
                  onClick={() => setShowCode(!showCode)}
                >
                  {showCode ? "Hide" : "Show"}
                </button>
              </div>

              <p className="mt-3">
                <strong>Share:</strong>
              </p>
              <div className="d-flex justify-content-center gap-3">
                <button
                  style={{ height: "43px", width: "43px" }}
                  className="btn btn-primary"
                >
                  <i className="fa-brands fa-facebook"></i>
                </button>
                <button
                  style={{ height: "43px", width: "43px" }}
                  className="btn btn-danger"
                >
                  <i className="fa-brands fa-instagram"></i>
                </button>
                <button
                  style={{ height: "43px", width: "43px" }}
                  className="btn btn-dark"
                >
                  <i className="fa-brands fa-x-twitter"></i>
                </button>
                <button
                  style={{ height: "43px", width: "43px" }}
                  className="btn btn-success"
                >
                  <i className="fa-brands fa-whatsapp"></i>
                </button>
              </div>
            </div>

            <a href="#" className="text-white mt-3 d-block">
              See My Earnings
            </a>
            <p className="mt-2">
              * 1 point = 1 INR <br /> * Offer Valid till 25 Dec'2025
            </p>
          </div>
          <div className="container mt-4">
            {/* How Refer & Earn Works */}
            <div className="card p-4 shadow-sm">
              <h5 className="fw-bold mb-3">How Refer & Earn Works</h5>

              <div className="d-flex align-items-start mb-3">
                <i className="fa-solid fa-mobile-screen fa-2x text-primary me-3"></i>
                <div>
                  <h6 className="fw-bold mb-1">LOGIN</h6>
                  <p className="mb-0">
                    Login & we will assign a unique referral code to you
                  </p>
                </div>
              </div>

              <div className="d-flex align-items-start mb-3">
                <i className="fa-solid fa-envelope fa-2x text-info me-3"></i>
                <div>
                  <h6 className="fw-bold mb-1">Invite</h6>
                  <p className="mb-0">
                    Share the referral code with your friends & help them sell
                    their phone at best price
                  </p>
                </div>
              </div>

              <div className="d-flex align-items-start">
                <i className="fa-solid fa-sack-dollar fa-2x text-warning me-3"></i>
                <div>
                  <h6 className="fw-bold mb-1">Earn</h6>
                  <p className="mb-0">Earn points equivalent to real money</p>
                </div>
              </div>

              <a href="#" className="text-success mt-3 d-block">
                View detailed T&C
              </a>
            </div>

            {/* FAQs Section */}
            <div className="card p-4 shadow-sm mt-3">
              <h5 className="fw-bold">FAQs</h5>

              <div className="accordion mt-3" id="faqAccordion">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#faq1"
                    >
                      What is Refer & Earn?
                    </button>
                  </h2>
                  <div
                    id="faq1"
                    className="accordion-collapse collapse"
                    data-bs-parent="#faqAccordion"
                  >
                    <div className="accordion-body">
                      It is as simple as brewing a hot cuppa. All you need to do
                      is log in & start sharing the referral code with your
                      friends who are looking to sell phones or get their phone
                      screens repaired
                    </div>
                  </div>
                </div>

                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#faq2"
                    >
                      What are My Points?
                    </button>
                  </h2>
                  <div
                    id="faq2"
                    className="accordion-collapse collapse"
                    data-bs-parent="#faqAccordion"
                  >
                    <div className="accordion-body">
                      Points are rewards you earn when your referred friends
                      complete a transaction. Each point is equivalent to 1 INR
                      and can be redeemed for future purchases or repairs.
                    </div>
                  </div>
                </div>

                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#faq3"
                    >
                      How do I use My Points?
                    </button>
                  </h2>
                  <div
                    id="faq3"
                    className="accordion-collapse collapse"
                    data-bs-parent="#faqAccordion"
                  >
                    <div className="accordion-body">
                      You can use your points during checkout. Simply select
                      'Use Points' option and specify how many points you want
                      to redeem. The equivalent amount will be deducted from
                      your total bill.
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#faq4"
                    >
                      How many friends can I invite?
                    </button>
                  </h2>
                  <div
                    id="faq4"
                    className="accordion-collapse collapse"
                    data-bs-parent="#faqAccordion"
                  >
                    <div className="accordion-body">
                      There is no limit to how many friends you can invite. The
                      more friends you refer who complete valid transactions,
                      the more points you earn!.
                    </div>
                  </div>
                </div>

                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#faq5"
                    >
                      I have registered. Now, how to invite friends?
                    </button>
                  </h2>
                  <div
                    id="faq5"
                    className="accordion-collapse collapse"
                    data-bs-parent="#faqAccordion"
                  >
                    <div className="accordion-body">
                      After registration, visit the 'Refer & Earn' page to get
                      your unique referral code. Share this code with friends
                      via WhatsApp, Facebook, Instagram, or any other platform.
                      You can also share directly from the app using the social
                      sharing buttons.
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#faq6"
                    >
                      Is there any validity of the points?
                    </button>
                  </h2>
                  <div
                    id="faq6"
                    className="accordion-collapse collapse"
                    data-bs-parent="#faqAccordion"
                  >
                    <div className="accordion-body">
                      Yes, the points are valid until the date mentioned in the
                      offer terms. Currently, points are valid until 25
                      Dec'2025. Make sure to use them before they expire.
                    </div>
                  </div>
                </div>

                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#faq7"
                    >
                      I have a referral code, how do I use it?
                    </button>
                  </h2>
                  <div
                    id="faq7"
                    className="accordion-collapse collapse"
                    data-bs-parent="#faqAccordion"
                  >
                    <div className="accordion-body">
                      If you have received a referral code, enter it during
                      registration or in the 'Apply Referral Code' section under
                      your profile. Once applied successfully, you'll receive
                      Rs.100 on your first qualifying transaction.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <br />
        <Footer />
      </div>

      <style>
        {`
                .inner-box {
                    width: 100%;
                    max-width: 600px;
                    min-width: 280px;
                    padding: 20px;
                    box-shadow: 0px 4px 10px rgba(0,0,0,0.1);
                }

                .code-text {
                    letter-spacing: 3px;
                    font-size: 1.2rem;
                }

                @media (max-width: 500px) {
                    .inner-box {
                        min-width: 90%;
                    }
                }
                `}
      </style>
    </>
  );
};

export default EarnAndReferPage;
